import {Pipe, Injectable, PipeTransform} from "@angular/core";
@Pipe({
  name: 'filter'
})
@Injectable()
export class FilterPipe implements PipeTransform {
  transform(items: any[], field : string, value : string): any[] {
    if (!items) return [];
    if (value == ""){ return items; }
    return items.filter(it => it[field] && it[field].toLowerCase().indexOf(value.toLowerCase()) > -1);
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/filter.ts